import React, { useEffect, useState } from 'react';
import './index.scss';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import { debounce } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useIsTakeOverBySelf } from '@/utils/hooks';

const enum acceleratorOpenEnum {
  power = 'power',
  standard = 'standard',
  stable = 'stable',
  slow = 'slow',
}
const enumFindNumber = new Map<acceleratorOpenEnum, number>([
  [acceleratorOpenEnum.power, 0.8],
  [acceleratorOpenEnum.standard, 0.4],
  [acceleratorOpenEnum.stable, 0.25],
  [acceleratorOpenEnum.slow, 0.1],
]);

const btnList = [
  {
    type: acceleratorOpenEnum.power,
    ico: require('@/assets/images/monitor/power-default.png'),
    activeIco: require('@/assets/images/monitor/power-active.png'),
    text: '动力',
    value: enumFindNumber.get(acceleratorOpenEnum.power),
    clstag: CLSTAG.Throttle_Power,
  },
  {
    type: acceleratorOpenEnum.standard,
    ico: require('@/assets/images/monitor/standard-default.png'),
    activeIco: require('@/assets/images/monitor/standard-active.png'),
    text: '标准',
    value: enumFindNumber.get(acceleratorOpenEnum.standard),
    clstag: CLSTAG.Throttle_Standard,
  },
  {
    type: acceleratorOpenEnum.stable,
    ico: require('@/assets/images/monitor/stable-default.png'),
    activeIco: require('@/assets/images/monitor/stable-active.png'),
    text: '稳定',
    value: enumFindNumber.get(acceleratorOpenEnum.stable),
    clstag: CLSTAG.Throttle_Stable,
  },
  {
    type: acceleratorOpenEnum.slow,
    ico: require('@/assets/images/monitor/slow-default.png'),
    activeIco: require('@/assets/images/monitor/slow-active.png'),
    text: '慢速',
    value: enumFindNumber.get(acceleratorOpenEnum.slow),
    clstag: CLSTAG.Throttle_Slow,
  },
];
const AcceleratorOpen = (props: {
  vehicleName: string;
  cockpitNumber: string;
  takeOverBySelf: boolean;
  userName: string;
}) => {
  const maxTorque = useSelector(
    (state: RootState) => state.cockpitRealtime.maxTorque
  );
  const { vehicleName, cockpitNumber, userName } = props;

  const takeOverBySelf = useIsTakeOverBySelf();
  const defaultVal = takeOverBySelf
    ? maxTorque
    : enumFindNumber.get(acceleratorOpenEnum.stable)!;
  const [activeValue, setActiveValue] = useState<number>(defaultVal);
  useEffect(() => {
    setActiveValue(defaultVal);
  }, [defaultVal]);

  const changeAcceleratorOpen = debounce(async (value: number) => {
    return request({
      path: '/monitor/web/drive/command/send/torque-control',
      method: Method.POST,
      body: {
        cockpitNumber: cockpitNumber,
        vehicleName: vehicleName,
        cockpitUserName: userName,
        data: value,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        message.success('指令下发成功');
        setActiveValue(value);
      } else {
        message.error(res.message);
      }
    });
  }, 500);
  return (
    <div className="accelerator-setting">
      {btnList.map((i) => (
        <a
          clstag={i.clstag}
          key={i.type}
          className={i.type}
          style={{
            backgroundImage:
              i.value === activeValue ? `url(${i.activeIco})` : `url(${i.ico})`,
            color: i.value === activeValue ? '#fff' : 'rgba(136,152,189,1)',
          }}
          onClick={() => {
            if (takeOverBySelf) {
              changeAcceleratorOpen(i.value);
            } else {
              message.error('用户未接管车辆,不允许操作!');
            }
          }}
        >
          {i.text}
        </a>
      ))}
    </div>
  );
};

export default React.memo(AcceleratorOpen);
